<template>
  <TabList
    :activeTab="activeTab"
    :class="$style.tabContainer"
    :customActiveTabStyle="$style.activeTabHeader"
    :customNavStyle="$style.navList"
    :customTabStyle="$style.tabHeader"
    :tabs="tabs"
    @active-tab-change="handleActiveTabChange"
  />
</template>

<script>
import TabList from 'components/TabList/TabList.vue';

/**
 * Interface mimics Segmented Button in jumpcloud-ui-components
 * https://github.com/TheJumpCloud/jumpcloud-ui-components/blob/master/src/components/Inputs/SegmentedButton.vue
 */
export default {
  name: 'SegmentedButton',
  components: {
    TabList,
  },
  props: {
    darkBg: Boolean,
    disabled: Boolean,
    /**
     * Not used but here because it will be required in jumpcloud-ui-components
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * @value ({ label: String, value: Any }[]}
     */
    options: {
      type: Array,
      required: true,
      validator: value => value.length > 1 && value.length < 4,
    },
    value: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    activeTab() {
      const index = this.options.findIndex(option => option.value === this.value);
      if (index < 0) {
        return 0;
      }
      return index;
    },
    tabs() {
      return this.options.map(option => ({ title: option.label }));
    },
  },
  methods: {
    handleActiveTabChange(index) {
      this.$emit('change', this.options[index].value);
    },
  },
};

</script>

<style module>
.tabContainer {
  margin: 0;
}

.tabHeader {
  margin: 0;
}

.navList li {
  background-color: var(--jcGrey100);
  border: 1px solid var(--jcGrey);
  border-radius: 0 4px 4px 0;
  flex: 1;
  padding: 5px 0;
  text-align: center;
}

.navList li.activeTabHeader {
  background-color: var(--jcPrimary);
  border-color: var(--jcPrimary);
}

.navList li:first-of-type {
  border-radius: 4px 0 0 4px;
}

.navList a {
  color: var(--jcGrey800);
  font-size: 12px;
  font-weight: 600;
  padding: 0 15px;
}
</style>
